/**
 * 2022-01-12
 * 图标文本组件单元
 */

import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
const defaultData = {
    icon: '',
    title: 'Interior Design',
    des: "DELTA Pro's capacity starts at 3.6kWh. Enough for hours of heavy-duty use. ",
};

const defaultStyle = {
    wrapperWidth: '100%',
    wrapperHeight: 'auto',
    wrapperBackColor: 'transparent',
    wrapperPadding: 0,
    wrapperMargin: 0,
    wrapperBorder: 0,
    wrapperBorderRadius: 0,
    iconMargin: '0 0 40px 0',
    iconWidth: '80px',
    iconHeight: '80px',
    iconSize: '80px',
    iconColor: '#2873FF',
    titleColor: '',
    titleFontSize: '24px',
    titleLineHeight: '32px',
    desColor: '',
    desFontSize: '17px',
    desLineHeight: '28px',
    desMargin: '16px 0 0 0',
    fontClassTitle: 'font-family-semibold',
    fontClassDes: 'font-family-semibold',
    fontWeightTitle: 600,
    fontWeightDesc: 600,
};

/**
 * Style样式参数
 * @param cssStyle {
 *  wrapperWidth： 容器宽 string,
 *  wrapperHeight: 容器高 string,
 *  wrapperBackColor: 容器背景色 string,
 *  wrapperPadding: 容器padding string,
 *  wrapperMargin: 容器margin string,
 *  wrapperBorder: 容器边框 string,
 *  wrapperBorderRadius：容器边框幅度 string,
 *  iconMargin: icon图标margin string,
 *  iconWidth: icon宽 string,
 *  iconHeight: icon高 string,
 *  titleColor: 标题文字颜色 string,
 *  titleFontSize: 标题文字大小 string,
 *  titleLineHeight： 标题文字行高 string,
 *  desColor: 描述文字颜色 string,
 *  desFontSize: 描述文字大小 string,
 *  desLineHeight：描述文字行高 string,
 *  desMargin: 描述文字行的margin string
 * }
 */

/**
 * data 数据参数
 * @param data {
 *  icon：icon路径，
 *  title：标题文本,
 *  des：描述文本,
 * }
 */

export default function TextIconCell({ cssStyle, data }: any) {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    const styles = { ...defaultStyle, ...cssStyle };
    const dataObj = { ...defaultData, ...data };

    return (
        <div
            className={`${css.textIconCell} textIconCell`}
            style={{
                width: styles.wrapperWidth,
                height: styles.wrapperHeight,
                background: styles.wrapperBackColor,
                padding: styles.wrapperPadding,
                margin: styles.wrapperMargin,
                border: styles.wrapperBorder,
                borderRadius: styles.wrapperBorderRadius,
                wordSpacing: styles.wordSpacing,
            }}
        >
            <span
                className="icons"
                style={{
                    margin: locale === 'jp' ? '0 0 20px 0' : styles.iconMargin,
                    width: styles.iconWidth,
                    height: styles.iconHeight,
                    fontSize: styles.iconSize,
                    color: styles.iconColor,
                }}
            >
                {dataObj.icon}
            </span>
            <div className="box">
                <p
                    className={`title ${styles.fontClassTitle}`}
                    style={{
                        color: styles.titleColor,
                        fontWeight: styles.fontWeightTitle,
                        fontSize: styles.titleFontSize,
                        lineHeight: styles.titleLineHeight,
                        wordSpacing: styles.wordSpacing,
                    }}
                >
                    {dataObj.title}
                </p>
                <p
                    className={`des ${styles.fontClassDes}`}
                    style={{
                        color: styles.desColor,
                        fontWeight: styles.fontWeightDesc,
                        fontSize: locale === 'jp' ? '15px' : styles.desFontSize,
                        lineHeight: styles.desLineHeight,
                        margin: styles.desMargin,
                        wordSpacing: styles.wordSpacing,
                    }}
                >
                    {dataObj.des}
                </p>
            </div>
        </div>
    );
}
